<ng-container *ngIf="params.data && !params.isItemNameLabel">
<div class="sku_image" (click)="previewImage(params.data.Image,$event)">
  <img [src]="params.data.Image" />
</div>
<div class="sku">
  <div class="sku_title" [title]="params.data.Title">
    {{ params.data.Title }}
  </div>
    <div *ngIf="params.data.Name == 'Total:'">
      {{params.data.Name}}
    </div>
    <div class="sku_chips" *ngIf="params.data.Name !== 'Total:'">
      <app-sku-chip
        *ngIf="params.data.Sku"
        [name]="'SKU'"
        [value]="params.data.Sku"
        [link]="skuLink"
      ></app-sku-chip>
  
      <app-sku-chip
        *ngIf="params.data.Asin"
        [name]="'ASIN'"
        [value]="params.data.Asin"
        [link]="asinLink"
      ></app-sku-chip>
      <app-sku-chip
        *ngIf="params.data.Name"
        [name]="'Name'"
        [value]="params.data.Name"
        [clickFunction]="titleClicked.bind(this)"
      ></app-sku-chip>
      <div *ngIf="params.data.DuplicateSkuCount > 0">
        <i class="fal fa-exclamation-triangle icon-info ms-2" [matTooltip]="skuCount"></i>
    </div>
  </div>
</div>
</ng-container>
<ng-container *ngIf="params.isItemNameLabel">
  <label>Item Name:</label>
  <app-sku-chip
      *ngIf="params.data.Name"
      [name]="'Name'"
      [value]="params.data.Name"
      [clickFunction]="titleClicked.bind(this)"
    ></app-sku-chip>
</ng-container>
